import css from 'styled-jsx/css';

const styles = css.global`#energia-solar-blog {
  background-color: #fbfbfb;
  padding-top: 32px;
  padding-bottom: 40px;
}

#energia-solar-blog .is-desk {
  display: none;
}

#energia-solar-blog .is-mobi {
  overflow: hidden;
}

#energia-solar-blog .ctn-home-24 {
  position: relative;
}

#energia-solar-blog .energia-solar-blog-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 16px;
}

#energia-solar-blog .energia-solar-blog-slide {
  display: flex;
  justify-content: center;
  margin-right: 16px;
  margin-left: 0;
  flex: 0 0 272px;
}

#energia-solar-blog .energia-solar-blog-card {
  display: flex;
  flex-direction: column;
  color: #fff;
  width: 272px;
  min-height: 348px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #CCC;
}

#energia-solar-blog picture {
  width: 100%;
}

#energia-solar-blog img {
  width: 100%;
  height: 189px;
  object-fit: cover;
  border-radius: 4px;
}

#energia-solar-blog .energia-solar-blog-card-textos {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 8px 16px 11px;
}

#energia-solar-blog .energia-solar-blog-slide-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
}

#energia-solar-blog .energia-solar-blog-slide-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#energia-solar-blog .custom-carousel.embla {
  margin-bottom: 18px;
}


#energia-solar-blog .home-pagination {
  width: 100%;
  max-width: 288px;
  margin-left: auto;
  margin-right: auto;
}

#energia-solar-blog .home-pagination .enable-mobile-arrows {
  height: 24px;
  width: 24px;
  background-size: 24px 24px;
}

@media (min-width: 992px) {

  #energia-solar-blog { 
    padding-top: 88px;
    padding-bottom: 88px;
  }

  #energia-solar-blog .is-mobi {
    display: none;
  }

  #energia-solar-blog .is-desk {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: auto;
  }

  #energia-solar-blog .cards-desk {
    display: flex;
    justify-content: space-between;
  }

  #energia-solar-blog .energia-solar-blog-card {
    width: 100%;
    max-width: 379px;
  }

  #energia-solar-blog .energia-solar-blog-card-textos {
    padding: 8px 16px 32px;
    /* height: 178px; */
  }

}`;

export default styles;